"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertSystemLog = void 0;
const insertSystemLog = async (knex, { type, timestamp = new Date(), level = 'Info', details }) => {
    try {
        await knex
            .withSchema('log')
            .insert({
            type,
            timestamp,
            level,
            details,
        })
            .into('system_log');
    }
    catch (err) {
        console.error(`[SystemLogClient] Failed to insert system log:`, err);
    }
};
exports.insertSystemLog = insertSystemLog;
